/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  PriceSheetDTO,
  SearchRequest,
  SearchResultOfPriceSheetDTO,
  UpdatePriceSheetRequest
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Search price sheets.
 */
export const searchPriceSheets = (
    searchRequest: SearchRequest,
 options?: SecondParameter<typeof apiRequest<SearchResultOfPriceSheetDTO>>,) => {
      return apiRequest<SearchResultOfPriceSheetDTO>(
      {url: `/pricesheets/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchRequest
    },
      options);
    }
  /**
 * @summary Get a price sheet by its ID.
 */
export const getPriceSheet = (
    priceSheetID: string,
 options?: SecondParameter<typeof apiRequest<PriceSheetDTO>>,) => {
      return apiRequest<PriceSheetDTO>(
      {url: `/pricesheets/${priceSheetID}`, method: 'GET'
    },
      options);
    }
  /**
 * Delete a price sheet and its products. A price sheet can own hundreds of thousands of
 * pricing rows, so the deletion runs in the background and the endpoint returns immediately.
 * @summary Delete Price Sheet.
 */
export const deletePriceSheet = (
    priceSheetID: string,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/pricesheets/${priceSheetID}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Download a price sheet from S3.
 * @summary Download Price Sheet.
 */
export const downloadPriceSheet = (
    priceSheetID: string,
 options?: SecondParameter<typeof apiRequest<Blob>>,) => {
      return apiRequest<Blob>(
      {url: `/pricesheets/${priceSheetID}/download`, method: 'GET',
        responseType: 'blob'
    },
      options);
    }
  /**
 * Update a price sheet.
 * @summary Update Price Sheet.
 */
export const updatePriceSheet = (
    updatePriceSheetRequest: UpdatePriceSheetRequest,
 options?: SecondParameter<typeof apiRequest<PriceSheetDTO>>,) => {
      return apiRequest<PriceSheetDTO>(
      {url: `/pricesheets`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePriceSheetRequest
    },
      options);
    }
  export type SearchPriceSheetsResult = NonNullable<Awaited<ReturnType<typeof searchPriceSheets>>>
export type GetPriceSheetResult = NonNullable<Awaited<ReturnType<typeof getPriceSheet>>>
export type DeletePriceSheetResult = NonNullable<Awaited<ReturnType<typeof deletePriceSheet>>>
export type DownloadPriceSheetResult = NonNullable<Awaited<ReturnType<typeof downloadPriceSheet>>>
export type UpdatePriceSheetResult = NonNullable<Awaited<ReturnType<typeof updatePriceSheet>>>
